import { Popover, Step, StepConnector, StepIconProps, StepLabel, Stepper, Typography, stepConnectorClasses, styled, useTheme } from '@mui/material'
import React, { useContext, useState } from 'react'
import { Check } from '@material-ui/icons'
import { MetaData, labelMappings } from '../utils/utils'
import { CouponStepperPropsTypes, SchemePlaygroundType } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { reinitialiseCurrentTab, switchOffReduxState, switchPlaygroundMode } from '../../../stateManagement/actions/manageCouponActions';
import { useSelector } from 'react-redux';
import { useMantineColorScheme } from '@mantine/core';
import { toggleModeInLocalStorage, togglePlaygroundModeInLocalStorage } from '../services/schemePlaygroundService';
import { ConfirmationPopUp } from '../../../components/popup/confirmationPopUp';
import store from '../../../stateManagement/store';
import CouponConfigurableLabel from './CouponConfigurableLabel';


const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: 'var(--dashboard-theme-color)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: 'var(--dashboard-theme-color)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 5,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
    margin: "0 2px"
  },
}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const showNumberIcon = (icon: string) => {
    return <div>{icon}</div>
  }
  return (
    <div className={`coupon-StepIcon-wrapper ${completed ? 'step-completed' : active ? 'step-active' : ''} ${className}`}>
      {
        completed ? <Check /> : showNumberIcon(String(props.icon))
      }
    </div>
  );
}


function CouponStepper(props: CouponStepperPropsTypes) {
  const { handleStepIconClick, currentStep } = props;
  return (
    <Stepper activeStep={currentStep} connector={<ColorlibConnector />}>
      {MetaData.Coupon_Step_Options.map((label:any, idx:any) => {
        const active = Number(idx) === Number(currentStep);
        const completed = Number(idx) < Number(currentStep);
        return <Step key={label}>
          <StepLabel sx={{ cursor: 'pointer' }} StepIconComponent={ColorlibStepIcon} onClick={() => handleStepIconClick(idx)}>
            <span className={`coupon-stepper-label ${active ? 'coupon-stepper-label-active' : completed ? 'coupon-stepper-label-completed' : ''}`}>{
              <CouponConfigurableLabel text={label} />
            }</span>
          </StepLabel>
        </Step>
      })}
    </Stepper>
  )
}

export interface CouponStepperDotOptionTypes {
  setAnchorEl?: React.Dispatch<React.SetStateAction<HTMLElement | null>>,
  anchorEl: HTMLElement | null,
  handleClose: () => void,
  handleClick: (event: any) => void
}


export function CouponStepperDotOption(props: CouponStepperDotOptionTypes) {
  const { isSchemePlayground } = useSelector((state: any) => state?.manageCoupons?.data);
  const { handleClick, anchorEl, handleClose, setAnchorEl} = props;
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const theme = useTheme();
  const [switchPopUpOpen, setSwitchPopUpOpen] = useState<boolean>(false);
  const data:SchemePlaygroundType = useSelector(() => store.getState().schemePlayground)
  const switchToPlaygroundMode = () => {
    handleClose();
    if(Object.keys(data.data).length !== 0){
      setSwitchPopUpOpen(true);
    }
    else{
      handleSwitchClick();
    }
  }
  
  const handleSwitchClick = async () => {
    switchPlaygroundMode();
    handleClose();
    // toggleModeInLocalStorage();
    // toggleColorScheme();
    togglePlaygroundModeInLocalStorage();
    // theme.palette.mode = 'dark';
    reinitialiseCurrentTab()
  }

  return (
    <div>
      <div onClick={handleClick} className="menuIcon menu-stepper">
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        <div className='scheme-info' onClick={() => { isSchemePlayground ? switchToPlaygroundMode() : handleSwitchClick() }}>
          <Typography variant='subtitle1'> {isSchemePlayground ? "Switch Off Playground mode" : "Switch On Playground mode"}</Typography>
        </div>
      </Popover>
      <ConfirmationPopUp
        openConfirmModal={switchPopUpOpen}
        setOpenConfirmModal={setSwitchPopUpOpen}
        message={labelMappings["SWITCH_OFF_PLAYGROUND_MODE"]}
        successMethod={() => { handleSwitchClick(); switchOffReduxState() }}
        rejectMethod={() => { setSwitchPopUpOpen(false); }}
      />
    </div>
  );
}

export default CouponStepper